export default "__VITE_ASSET__223b5ab1__"